import { fetchUtils } from "react-admin";
import { stringify } from "query-string";
import { parseJwt } from "./jwt";
import _ from "lodash";
import { apiUrl } from "../dataProvider";
import numeral from "numeral";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ONEMAP_API_URL } from "./const";
import axios from "axios";
import polyUtil from "polyline-encoded";
import { useState } from "react";

export const getUser = () => {
  return {
    user: {
      authenticated: true,
      token: `Bearer ${localStorage.getItem("token")}`,
    },
  };
};

export const colors = [
  "#016a02",
  "#011f03",
  "#2196f3",
  "#3f51b5",
  "#00bcd4",
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#ffc107",
];

export const httpClient = fetchUtils.fetchJson;

interface Get {
  json: any;
  status: number;
}

export const getReport = (
  type: string,
  from: string,
  to: string
): Promise<any> => {
  const url = `${apiUrl}/reports?FromDateTime=${from}&ToDateTime=${to}&Type=${type}`;
  return httpClient(url, getUser())
    .then(({ json, status }: any) => {
      return { json, status };
    })
    .catch((error: any) => console.log(error));
};

export const getDataFromJson = (url: string): Promise<any> => {
  return httpClient(url)
    .then(({ json, status }: any) => {
      return { json, status };
    })
    .catch((error: any) => console.log(error));
};

export const getBusEta = async (callback: (data: any) => void) => {
  let allRouteLocation: any[] = [];

  try {
    const routes: any = await httpClient(
      `${apiUrl}/Routes?Filter={"TenantId": ${process.env.REACT_APP_TENANT_ID}}`
    ).then(({ json, status }: any) => {
      return { json, status };
    });

    console.log(routes);

    if (routes) {
      const ids = _.map(routes.json, "id");

      console.log("IDS", ids);
      //populate all routeLocations from many routes
      await Promise.all(
        ids.map(async (id) => {
          const routesRes: any = await httpClient(
            `${apiUrl}/routes/${id}`
          ).then(({ json, status }: any) => {
            return { json, status };
          });
          if (routesRes) {
            allRouteLocation = [
              ...allRouteLocation,
              ...routesRes.json.routeLocations,
            ];
          }
        })
      );

      let locationIds = _.uniq(_.map(allRouteLocation, "locationId"));
      let allLocations: any[] = [];
      await Promise.all(
        locationIds.map(async (id, index) => {
          const locationRes: any = await httpClient(
            `${apiUrl}/locations/${id}`
          ).then(({ json, status }: any) => {
            return { json, status };
          });
          if (locationRes) {
            locationRes.json.color = colors[index];
            allLocations = [...allLocations, locationRes.json];
          }
        })
      );

      console.log("All Locations", allLocations);

      let etaByVehicle: any[] = [];

      //filter all route location, select only item that has vehicle eta on it
      const notEmptyVehicleEtas = _.filter(allRouteLocation, (item: any) => {
        return item.vehicleEtas.length !== 0;
      });

      //populate all vehicle eta
      notEmptyVehicleEtas.forEach((item: any) => {
        etaByVehicle = [...etaByVehicle, ...item.vehicleEtas];
      });

      callback({ notEmptyVehicleEtas, allLocations, ids });
    }
  } catch (error) {
    console.log(error);
  }
};

export const money = (price: number | string) =>
  numeral(price).format("0,0.00");

export const GetParam = () => {
  return new URLSearchParams(useLocation().search);
};

export const AcademicYearResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.academicYears?.data[id]
  );

  return data;
};

export const AcademicTermResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.academicTerms.data[id]
  );

  return data;
};

export const StudentResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.students.data[id]
  );

  return data;
};

export const PICResource = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.personInCharges.data[id]
  );
  return data;
};

export const ParentResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.parents.data[id]
  );

  return data;
};

export const SchoolIdSelected = () => {
  const data = useSelector(({ navMode }: any) => navMode.school?.id);

  return data;
};

export const SchoolResourceSelected = () => {
  const data = useSelector(({ navMode }: any) => navMode.school);

  return data;
};

export const BusSchedulePlanResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.busSchedulePlans.data[id]
  );

  return data;
};

export const BusScheduleResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.busSchedules.data[id]
  );

  return data;
};

export const UserResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.users.data[id]
  );

  return data;
};

export const LevelResources = (id: number) => {
  const data = useSelector(
    (resource: any) => resource.admin.resources.levels.data[id]
  );

  return data;
};

export const getToken = async () => {
  return await httpClient(`${apiUrl}/misc/oneMapToken`, {
    method: "POST",
    ...getUser(),
  }).then(({ json, status }: any) => {
    return { json, status };
  });
};

export const getRouteService = async (
  startCoordinate: any,
  endCoordinate: any,
  token: any
) => {
  const start = `${startCoordinate.lat},${startCoordinate.lng}`;
  const end = `${endCoordinate.lat},${endCoordinate.lng}`;
  const url = `${ONEMAP_API_URL}/public/routingsvc/route?start=${start}&end=${end}&routeType=drive`;

  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const routes = await axios.get(url, config);

    const decode = decodeRoute(routes.data.route_geometry);

    return transformDecodeRoute(decode);
  } catch (e) {
    console.log(e);
  }
};

const decodeRoute = (geometry: string) => {
  if (geometry !== undefined || geometry !== "" || geometry !== null) {
    var latLngs = polyUtil.decode(geometry, {
      precision: 5,
    });

    // Result
    // [
    //   [0.000],[0.000],
    //   ...
    // ]

    return latLngs;
  }
};

const transformDecodeRoute = (decodeRoutes: any) => {
  let results: any = [];

  decodeRoutes.forEach((decodeRoute: any) => {
    let result = { lat: decodeRoute[0], lng: decodeRoute[1] };

    results.push(result);
  });

  // Result
  // [
  //   {lat: xxx, lng: xxx},
  //   ...
  // ]

  return results;
};

export const sumCentsAmountToDolar = (datas: IResultCalculationItem[]) => {
  return datas.reduce((a: number, b: any) => a + b.total, 0) / 100;
};

export const sumCentsAmount = (datas: IResultCalculationItem[]) => {
  return datas.reduce((a: number, b: any) => a + b.total, 0);
};

export const availableOnlySuperAdminAndAdminAndFinance = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return (
    roles.includes("superadmin") ||
    roles.includes("admin") ||
    roles.includes("finance")
  );
};

export const getCustomerType = (type: string) => {
  switch (type) {
    case "parent":
      return "parent";
    case "company_person_in_charge":
      return "person in charge";
    default:
      break;
  }
};

export const getResourceByCustomerType = (type: string) => {
  switch (type) {
    case "parent":
      return "parents";
    case "company_person_in_charge":
      return "personInCharges";
    default:
      break;
  }
};

export const centToDollar = (cent: any) => {
  return cent.toFixed(2) / 100;
};

export const delay = (ms: number) => {
  return new Promise((res) => setTimeout(res, ms));
};

export const capitalizeFirstLetter = (string: string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : null;
};

export const meterToKilometer = (distance: number) => {
  return distance / 1000;
};

export const getUserIdFilterBasedOnRole = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  const rolesFiltered = ["admin", "school"];
  let filter = {};

  if (roles.some((role) => rolesFiltered.includes(role))) {
    filter = { UserId: Number(localStorage.getItem("userId")) };
  }

  return filter;
};
